import ViewBase from "../view-base.view";
import SurveyListItemView from "./survey-list-item.view";
import SurveyResultDownloadView from "./survey-result-download.view";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import MultiSelectComponent from "../../components/multi-select/multi-select.component";
import SelectUserComponent from "../../components/user/select-user.component";
import paginationComponent from "../../components/pagination/pagination.component";
import SelectSiteComponent from "../../components/site/select-site.component";
import SelectSiteGroupComponent from "../../components/site/select-site-group.component";
import { Dialog } from "construct-ui";
import surveyModel from "../../models/survey/survey.model";
import loginModel from "../../models/login.model";
import codeMasterModel from "../../models/common/code-master.model";
import userSearchModal from "../../models/common/user-search.modal";
import languageModel from "../../models/language.model";
import { formats as FORMATS, codeMasterType } from "../../config/constants";
import moment from "moment";
import _ from "lodash";
import LocationTreeCheckboxComponent from "../../components/location/location-tree-checkbox.component";

export default function SurveySearchView() {
  ViewBase.call(this);

  let viewUpdateSurveyQuestions = () => { };
  let viewUpdateSurveyInfo = () => { };

  let isSelectedAll = false;
  let selectedSurveyList = [];
  let surveyList = [];
  let surveyTypeList = [];
  let surveyTypeLegendMap = null;
  let gscmDivList = [];
  let userRoleOptionList = [];
  let normalSurveyTypeList = [];
  let frequencyList = [];

  let showSurveyResultDownloadModal = false;
  let isDownloadingFiles = [false, false];

  let sortOptions = [
    { code: 0, get name() { return languageModel.getText("LT00000529", "Survey Start Date: Latest first") }, sortBy: 'fromDate', order: 'DESC' },
    { code: 1, get name() { return languageModel.getText("LT00000530", "Survey Start Date: Oldest first") }, sortBy: 'fromDate', order: 'ASC' },
    { code: 2, get name() { return languageModel.getText("LT00000531", "Survey End Date: Latest first") }, sortBy: 'toDate', order: 'DESC' },
    { code: 3, get name() { return languageModel.getText("LT00000532", "Survey End Date: Oldest first") }, sortBy: 'toDate', order: 'ASC' },
    { code: 4, get name() { return languageModel.getText("LT00000533", "Survey Category: A - Z") }, sortBy: 'category', order: 'ASC' },
    { code: 5, get name() { return languageModel.getText("LT00000534", "Survey Category: Z - A") }, sortBy: 'category', order: 'DESC' },
    { code: 6, get name() { return languageModel.getText("LT00000535", "Survey Title: A - Z") }, sortBy: 'title', order: 'ASC' },
    { code: 7, get name() { return languageModel.getText("LT00000536", "Survey Title: Z - A") }, sortBy: 'title', order: 'DESC' },
  ];
  let selectedSortOption = sortOptions[0];
  let selectedSortIndex = 0;

  let activeOptions = [
    { code: 'Y', name: this.getText("LT00000023", "Yes") },
    { code: 'N', name: this.getText("LT00000024", "No") },
  ];

  const DEFAULT_FILTER_PARAMS = Object.freeze({
    fromDate: moment().add(-6, 'd').format(FORMATS.apiDateFormat),
    toDate: moment().format(FORMATS.apiDateFormat),
    sortBy: selectedSortOption.sortBy,
    orderBy: selectedSortOption.order,
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    surveyCategory: "",
    title: "",
    selectedSurveyTypeList: Object.freeze([]),
    selectedGscmDivList: Object.freeze([]),
    selectedTargetUserList: Object.freeze([]),
    selectedUserRoleList: Object.freeze([]),
    selectedUserList: Object.freeze([]),
    selectedSiteList: Object.freeze([]),
    selectedSiteGroupList: Object.freeze([]),
    selectedActiveOption: Object.freeze([]),
    selectedNormalSurveyType: Object.freeze([]),
    selectedFrequency: Object.freeze([]),
    selectedLocationList: Object.freeze([])
  });

  let filterParams = _.cloneDeep(DEFAULT_FILTER_PARAMS);
  let lastSearchedFilterParams = _.cloneDeep(filterParams);

  let extractQueryParams = (params) => {
    // Only create key value pair when there is value
    let queryParam = Object.assign({},
      _.isEmpty(params.fromDate) ? null : { fromDate: params.fromDate },
      _.isEmpty(params.toDate) ? null : { toDate: params.toDate },
      _.isEmpty(params.sortBy) ? null : { sortBy: params.sortBy },
      _.isEmpty(params.orderBy) ? null : { orderBy: params.orderBy },
      !params.pageIndex ? null : { pageIndex: params.pageIndex },
      !params.pageSize ? null : { pageSize: params.pageSize },
      !params.totalCount ? null : { totalCount: params.totalCount },
      _.isEmpty(params.surveyCategory) ? null : { surveyCategory: params.surveyCategory },
      _.isEmpty(params.title) ? null : { title: params.title },
      _.isEmpty(params.selectedSurveyTypeList) ? null : { surveyType: params.selectedSurveyTypeList.map(x => x.code).join('^') },
      _.isEmpty(params.selectedGscmDivList) ? null : { gscmDiv: params.selectedGscmDivList.map(x => x.code).join('^') },
      _.isEmpty(params.selectedTargetUserList) ? null : { targetUser: params.selectedTargetUserList.map(u => u.userID).join('^') },
      _.isEmpty(params.selectedUserRoleList) ? null : { targetUserRole: params.selectedUserRoleList.map(u => u.code).join('^') },
      _.isEmpty(params.selectedUserList) ? null : { createUserId: params.selectedUserList.map(u => u.userID).join('^') },
      _.isEmpty(params.selectedSiteList) ? null : { siteIds: params.selectedSiteList.map(x => x.code).join('^') },
      _.isEmpty(params.selectedSiteGroupList) ? null : { siteGroups: params.selectedSiteGroupList.map(g => g.code).join('^') },
      _.isEmpty(params.selectedLocationList) ? null :{locations : params.selectedLocationList.join('^')}
    );

    if (!_.isEmpty(params.selectedNormalSurveyType) && params.selectedNormalSurveyType.code !== '') {
      queryParam.type = params.selectedNormalSurveyType.code;
    }

    if (!_.isEmpty(params.selectedActiveOption) && params.selectedActiveOption.code !== '') {
      queryParam.active = params.selectedActiveOption.code;
    }

    if (!_.isEmpty(params.selectedFrequency) && params.selectedFrequency.code !== '') {
      queryParam.frequency = params.selectedFrequency.code;
    }

    return queryParam;
  };

  let getSurveyList = (viewState) => {
    this.showLoading();
    surveyList = [];

    // Reset survey selection
    isSelectedAll = false;
    selectedSurveyList.splice(0, selectedSurveyList.length);

    surveyModel.getSurveyList(
      (result) => {
        lastSearchedFilterParams = _.cloneDeep(filterParams);
        surveyList = result.data;
        filterParams.pageIndex = result.pageIndex;
        filterParams.pageSize = result.pageSize;
        filterParams.totalCount = result.total;
        this.hideLoading();

        viewState.saveState(surveyList, filterParams);
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      extractQueryParams(filterParams)
    );
  };

  let _search = (viewState) => {
    filterParams.pageIndex = 1; // Always go back to page 1 
    getSurveyList(viewState);
  }

  let _clearFilter = (viewState) => {
    filterParams = _.cloneDeep(DEFAULT_FILTER_PARAMS);
    // Reload data
    getSurveyList(viewState);
  }

  let getSurveyTypeList = () => {
    codeMasterModel.getByCategory(
      (result) => {
        result.map(e => {
          surveyTypeList.push({ ...e });
        });

        surveyTypeLegendMap = result.reduce((previousValue, currentValue) => {
          previousValue[currentValue.code] = currentValue;
          return previousValue;
        }, {});

        // Get color codes
        codeMasterModel.getByCategory(
          (colorResult) => {
            colorResult.forEach((color) => {
              if (surveyTypeLegendMap?.hasOwnProperty(color.code)) {
                surveyTypeLegendMap[color.code].color = color.name;
              }
            });
          },
          (error) => {
            this.handleError(error);
          },
          { category: codeMasterType.surveyTypeColor } // SurveyTypeColor
        );

      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.type } // SurveyType
    );
  }

  let getGscmDivList = () => {
    codeMasterModel.getByCategory(
      (result) => {
        gscmDivList = result;
      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.gscmDiv } // SurveyType
    );
  }

  let getUserRoleList = () => {
    userSearchModal.getUserRoleList(
      (result) => {
        userRoleOptionList = result;
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  let getNormalSurveyTypeList = () => {
    codeMasterModel.getByCategory(
      (result) => {
        result.map(r => {
          normalSurveyTypeList.push({ ...r });
        });
      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.normalSurveyType } // NormalSurveyType
    );
  }

  let getFrequencyList = () => {
    codeMasterModel.getByCategory(
      (result) => {
        result.map(r => {
          frequencyList.push({ ...r });
        });
      },
      (error) => {
        this.handleError(error);
      },
      { category: codeMasterType.frequency } // Frequency
    );
  }

  let openSurveyResultDownloadModal = (e) => {
    e.preventDefault();
    showSurveyResultDownloadModal = true;
  }

  let downloadExcelForSiteLevelSummary = (e) => {
    e.preventDefault();
    if (isDownloadingFiles[1]) {
      return false;
    }
    isDownloadingFiles[1] = true;
    surveyModel.downloadExcelForSiteLevelSummary(
      (result) => {
        isDownloadingFiles[1] = false;
      },
      (error) => {
        isDownloadingFiles[1] = false;
        this.handleError(error);
      },
      loginModel.credentials.country,
      selectedSurveyList.join('^')
    );
    return false;
  }

  let downloadExcelForTargetResponse = (surveyId) => {
    surveyModel.downloadExcelForTargetResponse(
      (result) => {
      },
      (error) => {
        this.handleError(error);
      },
      {
        countryCode: loginModel.credentials.country,
        surveyId: surveyId,
        fromDate: lastSearchedFilterParams.fromDate,
        toDate: lastSearchedFilterParams.toDate,
      }
    );
    return false;
  }

  let onPageSizeChanged = (pageIndex, pageSize, viewState) => {
    filterParams.pageIndex = pageIndex;
    filterParams.pageSize = pageSize;
    getSurveyList(viewState);
  }

  let onPageChanged = (pageIndex, viewState) => {
    filterParams.pageIndex = pageIndex;
    getSurveyList(viewState);
  }

  let updateFilter = (e) => {
    let prop = e.currentTarget.id;
    let value = e.currentTarget.value;
    if (prop && prop.length > 0) {
      filterParams[prop] = value
    }
  }

  let sortSurveyList = (viewState) => {
    filterParams.sortBy = selectedSortOption.sortBy
    filterParams.orderBy = selectedSortOption.order;
    filterParams.pageIndex = 1; // Go back to page 1
    getSurveyList(viewState);
  }

  let selectSurvey = (surveyId) => {
    if (selectedSurveyList.includes(surveyId)) {
      return
    }
    selectedSurveyList.push(surveyId);
  }

  let deselectSurvey = (surveyId) => {
    if (selectedSurveyList.includes(surveyId)) {
      isSelectedAll = false;
      selectedSurveyList.splice(selectedSurveyList.indexOf(surveyId), 1)
    }
  }

  let checkboxClickEvent = (surveyId, isChecked) => {
    if (isChecked) {
      selectSurvey(surveyId);
    } else {
      deselectSurvey(surveyId);
    }
  }

  let selectAllChanged = (e) => {
    if (e.target.checked) {
      isSelectedAll = true;
      surveyList.map(s => {
        if (!selectedSurveyList.includes(s.surveyIdString)) {
          selectedSurveyList.push(s.surveyIdString);
        }
      })
    } else {
      isSelectedAll = false;
      selectedSurveyList.splice(0, selectedSurveyList.length);
    }
    m.redraw();
  }

  let initState = (viewState) => {
    if (viewState.listDirty) {
      getSurveyList(viewState);
    } else {
      surveyList = _.cloneDeep(viewState.surveyList);
      filterParams = _.cloneDeep(viewState.filterParams);
      selectedSortOption = sortOptions[viewState.selectedSortIndex];
    }
  };

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onManaged) {
        viewUpdateSurveyQuestions = vnode.attrs.onManaged;
      }
      if (vnode.attrs.onUpdateClick) {
        viewUpdateSurveyInfo = vnode.attrs.onUpdateClick;
      }

      initState(vnode.attrs.surveyViewState);

      // Filter dropdown options
      getSurveyTypeList();
      getGscmDivList();
      getUserRoleList();
      getNormalSurveyTypeList();
      getFrequencyList();
    },
    view: (vnode) => {
      return [
        m('.col-12',
          // Search section
          m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
            m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
              m('i.bi.bi-filter'),
              this.getText("LT00000232", "Filter"),
            ),
            m('#search-section.card.collapse',
              m('.card-body',
                m('.row.g-3.align-items-end',
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=title]', this.getText("LT00000037", "Title")),
                    m('input.form-control[id=title]', { onchange: updateFilter, value: filterParams.title })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=surveyCategory]', this.getText("LT00000348", "Survey Category")),
                    m('input.form-control[id=surveyCategory]', { onchange: updateFilter, value: filterParams.surveyCategory })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000351", "Survey Type")),
                    m(MultiSelectComponent, {
                      items: surveyTypeList,
                      selectedItems: filterParams.selectedSurveyTypeList,
                      onSelect: (s) => {
                        filterParams.selectedSurveyTypeList = s;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=period]', this.getText("LT00000150", "Period")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      grid: 1,
                      calendars: 1,
                      dateStart: moment(filterParams.fromDate).format(FORMATS.dateFormat), // default date range
                      dateEnd: moment(filterParams.toDate).format(FORMATS.dateFormat), // default date range
                      readonly: true,
                      onselect: (e) => {
                        filterParams.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
                        filterParams.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
                      }
                    })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=title]', this.getText("LT00000241", "GSCM Division")),
                    m(MultiSelectComponent, {
                      items: gscmDivList,
                      selectedItems: filterParams.selectedGscmDivList,
                      onSelect: (s) => {
                        filterParams.selectedGscmDivList = s;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000349", "Target Users")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        filterParams.selectedTargetUserList = u;
                      },
                      selectedUserList: filterParams.selectedTargetUserList,
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000495", "Target User Role")),
                    m(MultiSelectComponent, {
                      items: userRoleOptionList,
                      selectedItems: filterParams.selectedUserRoleList,
                      onSelect: (u) => {
                        filterParams.selectedUserRoleList = u;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000025", "Active")),
                    m(SingleSelectComponent, {
                      selectedItem: filterParams.selectedActiveOption,
                      checkmark: true,
                      items: activeOptions,
                      filterable: false,
                      onSelect: e => {
                        filterParams.selectedActiveOption = e;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000071", "Site")),
                    m(SelectSiteComponent, {
                      selectedItemList: filterParams.selectedSiteList,
                      onChange: (s) => {
                        filterParams.selectedSiteList = s;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: filterParams.selectedSiteGroupList,
                      onChange: (g) => {
                        filterParams.selectedSiteGroupList = g;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000117", "Type")),
                    m(SingleSelectComponent, {
                      selectedItem: filterParams.selectedNormalSurveyType,
                      checkmark: true,
                      items: normalSurveyTypeList,
                      filterable: false,
                      onSelect: e => {
                        filterParams.selectedNormalSurveyType = e;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000353", "Frequency")),
                    m(SingleSelectComponent, {
                      selectedItem: filterParams.selectedFrequency,
                      checkmark: true,
                      items: frequencyList,
                      filterable: false,
                      onSelect: e => {
                        filterParams.selectedFrequency = e;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000708", "Created User ID(s)")),
                    m(SelectUserComponent, {
                      default: {
                        userStatusCode: '0001'
                      },
                      onSelect: (u) => {
                        filterParams.selectedUserList = u;
                      },
                      selectedUserList: filterParams.selectedUserList,
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=locations]', this.getText('LT00000557', 'Location')),
                    m(LocationTreeCheckboxComponent, {
                      id: 'locations',
                      selectedCodes: filterParams.selectedLocationList,
                      isLevel1Expanded: true,
                      onChange: (v) => {
                        filterParams.selectedLocationList = v;
                      }
                    })
                  ),
                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary', {
                      onclick: () => {
                        _search(vnode.attrs.surveyViewState);
                      }
                    }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', {
                      onclick: () => {
                        _clearFilter(vnode.attrs.surveyViewState);
                      }
                    }, this.getText("LT00000031", "Clear")),
                  ),

                ),
              )
            ),
          ),

          // Survey List
          m('.d-flex.justify-content-end.align-items-end.gap-3.mb-2',
            m('.flex-shrink-0.d-flex.align-items-center', { style: 'padding-left: 12px;' },
              m('.form-check',
                m('input.form-check-input#select-all-survey[type=checkbox]', {
                  checked: isSelectedAll,
                  onchange: selectAllChanged,
                  disabled: surveyList.length === 0
                }),
                m('label.form-check-label[for=select-all-survey]', this.getText("LT00000077", "Select all"))
              ),
            ),
            m('.surveytype-legend.flex-grow-1.d-flex.flex-wrap.align-items-center.gap-3.ps-md-4.ps-lg-5.mb-1',
              surveyTypeLegendMap && Object.values(surveyTypeLegendMap).map(wt =>
                m('label', { style: 'white-space: nowrap;' },
                  m('.work-type-indicator', {
                    style: {
                      'border-color': wt.color,
                      'background-color': wt.color,
                    }
                  }),
                  wt.name
                ),
              ),
            ),
            m('div',
              m(SingleSelectComponent, {
                selectedItem: selectedSortOption,
                items: sortOptions,
                filterable: false,
                allowEmpty: false,
                onSelect: e => {
                  selectedSortIndex = sortOptions.findIndex(s => s.code === e.code);
                  selectedSortOption = sortOptions[selectedSortIndex];

                  vnode.attrs.surveyViewState.selectedSortIndex = selectedSortIndex;
                  sortSurveyList(vnode.attrs.surveyViewState);
                }
              })
            ),
            m('.input-group.w-auto',
              m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                {
                  disabled: (surveyList && surveyList.length > 0) ? false : true,
                },
                isDownloadingFiles.includes(true)
                  ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                  : m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText("LT00000492", "Download")
              ),
              m('ul.dropdown-menu',
                m('li', {
                  title: selectedSurveyList.length === 0 ? this.getText("EM00000369", "Please select one or more surveys") : '',
                },
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    class: (isDownloadingFiles[0] || selectedSurveyList.length === 0) ? 'disabled' : '',
                    onclick: openSurveyResultDownloadModal
                  },
                    isDownloadingFiles[0] &&
                    m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                    this.getText("LT00000537", "Survey Results")
                  )
                ),
                m('li', {
                  title: selectedSurveyList.length === 0 ? this.getText("EM00000369", "Please select one or more surveys") : '',
                },
                  m('a.dropdown-item[href="javascript:void(0);"]', {
                    class: (isDownloadingFiles[1] || selectedSurveyList.length === 0) ? 'disabled' : '',
                    onclick: downloadExcelForSiteLevelSummary
                  },
                    isDownloadingFiles[1] &&
                    m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                    this.getText("LT00000538", "Site Level Summary")
                  )
                ),
              ),
            ),
          ),
          m('.d-flex.flex-column.gap-2',
            surveyList && surveyList.length > 0
              ? surveyList.map((survey) =>
                m(SurveyListItemView, {
                  viewUpdateSurveyInfo: () => { viewUpdateSurveyInfo(survey.surveyId, survey.surveyIdString) },
                  viewUpdateSurveyQuestions: () => { viewUpdateSurveyQuestions(survey.surveyId, survey.surveyIdString) },
                  onResponseClick: () => { vnode.attrs.onResponseClick(survey.surveyId, survey.title) },
                  onGoBack: vnode.attrs.onGoBack,
                  downloadExcelForTargetResponse: () => downloadExcelForTargetResponse(survey.surveyIdString),
                  key: survey.surveyId,
                  isSelected: isSelectedAll || selectedSurveyList.includes(survey.surveyIdString),
                  onCheckboxChange: (surveyId, isChecked) => checkboxClickEvent(surveyId, isChecked),
                  survey: survey,
                  surveyColorCode: surveyTypeLegendMap?.[survey.surveyType]?.color
                })
              )
              : m('.text-center.my-5', this.getText("EM00000141", "No records found."))
          ),
          surveyList && surveyList.length > 0 &&
          m(".mt-3",
            m(paginationComponent, {
              currentPage: filterParams.pageIndex,
              pageSize: filterParams.pageSize,
              totalItems: filterParams.totalCount,
              onPageChanged: (pageIndex) => { onPageChanged(pageIndex, vnode.attrs.surveyViewState) },
              onPageSizeChanged: (pageIndex, pageSize) => { onPageSizeChanged(pageIndex, pageSize, vnode.attrs.surveyViewState) }
            })
          )
        ),
        m(Dialog, {
          class: 'modal-body-overflow-visible',
          closeOnOutsideClick: false,
          isOpen: showSurveyResultDownloadModal,
          onClose: (e) => { showSurveyResultDownloadModal = false; },
          title: this.getText("LT00000539", "Survey Result Download"),
          content: m(SurveyResultDownloadView, {
            surveyIdList: selectedSurveyList,
            closeModal: e => showSurveyResultDownloadModal = false
          }),
        }),
        this.getBaseViews()
      ]
    },
  };
}
